import validate from 'validate.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const validateVariablePricingForm = (values) => {
  const {
    name,
    rate,
    dows,
    pricingType,
    customStart,
    customEnd,
    afterStart
  } = values;

  validate.validators.dowTruthy = (value) => {
    const errorMessage = <FormattedMessage id="hosting.validate_variable_pricing_form.pick_a_day_message" defaultMessage="please pick a day" />;
    return validate.contains(value, true) ? undefined : errorMessage;
  };

  const result = {
    customStart: validate.single(customStart, {
      presence: 'custom' === pricingType,
      numericality: true
    }),
    customEnd: validate.single(customEnd, {
      presence: 'custom' === pricingType,
      numericality: true
    }),
    afterStart: validate.single(afterStart, {
      presence: 'after' === pricingType,
      numericality: true
    }),
    rate: validate.single(rate, {
      presence: { allowEmpty: false, message: <FormattedMessage id="hosting.validate_variable_pricing_form.enter_number_message" defaultMessage="Enter a number" /> },
      numericality: { lessThanOrEqualTo: 999999 }
    }),
    name: validate.single(name, {
      presence: { allowEmpty: false },
      length: { maximum: 30 }
    }),
    dows: {
      _error: validate.single(dows, {
        presence: true,
        dowTruthy: true
      })
    },
    pricingType: validate.single(pricingType, {
      presence: { allowEmpty: false }
    })
  };

  return result;
};

export default validateVariablePricingForm;
